<template>
  <v-alert class="alert my-2" :dense="true" :outlined="true" transition="scale-transition" dismissible @input="onInput">
    <span>{{ value.text }}</span>
  </v-alert>
</template>

<script>

export default {

  props: {
    index: undefined,
    value: {
      text: {
        type: String,
        default: ""
      }
    },
  },
  methods: {
    onInput(event) {
      console.log(event)
      if (!event) {
        this.$emit('dismissed', this.index)
      }
    }
  }
  // data() {
  //   return {
  //     visibility: true
  //   }
  // },
  // watch: {
  //   visibility (val) {
  //     if (val) {
  //       // Custom action when the alert was shown
  //     } else {
  //       // Custom action when the alert was hidden
  //       console.log('remove!')
  //     }
  //   }

}

</script>
